/*******************************************************************************
* Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
*                 This work contains trade secrets and confidential materials
*                 of Honeywell Inc., and its use or disclosure in whole or in
*                 part without express written permission of Honeywell Inc.
*                 is prohibited.
*
* Name          : NonMSAServiceOrder.tsx
*
* Project Title : Checkout
*
* Description   : Initial version
*
* Company       : Honeywell Technology Solutions , Hyderabad
*
* @Author       : H422336
*
* @Date         : Sep 14, 2020
*
* @Version      : Version 1.0
*
* By             : H422337
* On             : Sep 16,2020
* Description    : ASDS-3038 UI enhancements as part of phase-2
*
* By             : H422337
* On             : Sep 18,2020
* Description    : ASDS-3025 UI enhancements as part of phase-2
*
* By             : H422337
* On             : Sep 21,2020
* Description    : ASDS-3030 APU enhancements as part of phase-2
*
* By             : H422337
* On             : Sep 24,2020
* Description    : ASDS-3026 APU enhancements as part of phase-2
*
* By             : H422337
* On             : Sep 25,2020
* Description    : ASDS-3028 APU enhancements as part of phase-2
*
* By            : H422337
* On            : Sep 25, 2020
* Description   : ASDS - 3225- Bug fixes for Phase - II
*
* By             : H422337
* On             : Sep 30,2020
* Description    : ASDS-3230 APU enhancements as part of phase-2
*
* By             : H422337
* On             : Oct 1,2020
* Description    : ASDS-3234 APU enhancements as part of phase-2
*
* By             : H422336
* On             : Oct 06,2020
* Description    : ASDS-3227 APU enhancements as part of phase-2
*
* By            : H422337
* On            : Oct 08, 2020
* Description   : ASDS - 3438 UI Enhancements for phase-2 bugfixes
*
* By            : H422337
 * On            : Oct 09, 2020
 * Description   : ASDS - 3260 UI Enhancements for Phase - II
 *
 * By            : H422337
 * On            : Oct 09, 2020
 * Description   : ASDS - 3261 UI Enhancements for phase-2
 *
 * By            : H422337
 * On            : Nov 18, 2020
 * Description   : ASDS - 4073 - selection checkbox bug fixes - Phase-2
 *
******************************************************************************/
import * as React from 'react';
import { Notification, Icon, Grid, Input, }  from '@scuf/common';
import { DataTable } from '@scuf/datatable';
import '@scuf/common/honeywell/theme.css';
import './addAPUSerialNumbers.css';
import './ConfigureAPU.css';
import '@scuf/datatable/honeywell/theme.css';
import { connect } from 'react-redux';
import ConfigureAPUActions from '../redux/actions/configure-apu-actions';
import { APUSubProductI } from '../utils/checkout-interfaces';
import { ICellData } from '@scuf/datatable/dist/components/DataTable/IDataTableInterfaces';
import { ApuErrorLabels } from '../constants/checkout-constants';
import { InLineLoader } from '../Loader/Loader';

interface  IServiceOrderProductDatas {
    enableNextBtn: boolean;
    serviceOrderDatas: IServiceOrderProductData[];
    updateNonMsaSerial: Function;
    updateNonMsaServiceOrder: Function;
    featuresMasterData: APUSubProductI[];
    addRow: Function;
    hideAPUValidationErrMsg: Function;
    deleteNonMsaSORow: Function;
    isValidateServiceOrderSuccess: boolean;
    isValidateServiceOrder: boolean;
    showAPUValidationErrorMsg: boolean;
}

interface IServiceOrderProductData {
    acOem: string;
    oemError: string;
    serialNumber: string;
    serialNumberError: string;
    serviceOrderNumber: string;
    serviceOrderNumberError: string;
    unitPrice: number;
    subProductId: string;
}

class NonMSAServiceOrder extends React.Component<IServiceOrderProductDatas, any> {

    constructor(props: any){
        super(props);
        this.state = {
            selectedRowData: []
        };
        this.rowExpansionTemplate = this.rowExpansionTemplate.bind(this);
        this.handleRetry = this.handleRetry.bind(this);
    }
    handleRetry() {
        if (!this.props.isValidateServiceOrderSuccess) {
            this.props.addRow();
        }
    }
    render() {
        const Item = DataTable.ActionBar.Item;
        let ErrorRowData = this.props.serviceOrderDatas.filter((product: any) => {
            if (typeof product.validInputData !== 'undefined' && !product.validInputData && (product.serialNumberError !== '' || product.serviceOrderNumberError !== '')){
                return product;
            }
    });
        return (
            <React.Fragment>
            <Grid>
                    <Grid.Row>
                        <Grid.Column width={12}>
                            {(!this.props.isValidateServiceOrderSuccess) &&
                                <Notification
                                    hasIcon={true}
                                    title={'There is an error in processing your request.'}
                                    severity="critical"
                                    detailsText="Retry"
                                    onDetailsClick={this.handleRetry}
                                />
                            }
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                {this.props.isValidateServiceOrderSuccess &&
                <React.Fragment>
                  <div className="details-nonmsa-table data-table-heading"> Enter details for Key with Service Order </div>

                        <DataTable
                            data={this.props.serviceOrderDatas}
                            onEdit={(newVal: any, cellData: ICellData) => this.updateRowValue(newVal, cellData)}
                            selectionMode="multiple"
                            expandedRows={ErrorRowData}
                            rowExpansionTemplate={this.rowExpansionTemplate}
                            selection={this.state.selectedRowData}
                            onSelectionChange={(e) => this.setState({ selectedRowData: e })}
                        >
                            <DataTable.HeaderBar>
                                            <DataTable.HeaderBar.Item
                                                content="Add"
                                                iconSize="small"
                                                icon="slidercontrols-plus"
                                                onClick={() => this.addAPUMultipleRow()}
                                            />
                            </DataTable.HeaderBar>
                            <DataTable.ActionBar>
                                <Item
                                    icon={<Icon name="delete" root="common" size="small" />}
                                    content="Delete"
                                    onClick={() => this.deleteMultipleItems()}
                                />
                            </DataTable.ActionBar>
                            <DataTable.Column field="serialNumber" header="APU Serial No." align="left" placeholder="Enter Serial No." renderer={(cellData) =>this.serialNumberRenderer(cellData)}/>
                            <DataTable.Column field="serviceOrderNumber" header="Service Order No."  align="left" placeholder="Enter Order No." renderer={(cellData) =>this.serviceOrderNumberRenderer(cellData)} />
                            <DataTable.Column field="unitPrice" header="Unit Price"  align="left" renderer={this.unitPriceDisplay} />
                        </DataTable>
                <Grid>
                    <Grid.Row>
                        <Grid.Column width={12}>
                                {this.props.isValidateServiceOrder &&
                                <InLineLoader  loading={true} text="Validating Service Order Number" overlayColor="transparent" >
                                </InLineLoader>
                            }
                            </Grid.Column>
                            </Grid.Row>
                            </Grid>
                            </React.Fragment>
    }
        </React.Fragment>
            );
    }

    unitPriceDisplay( cellData: ICellData) {
        return <span>${cellData.value.toFixed(2)}</span>;
    }

    rowExpansionTemplate(data){
         let errorMsg: string = '';
         let errorTitle: string = '';

         if (data.serviceOrderNumberError !== '') {
    errorMsg = data.serviceOrderNumberError;
    if (errorMsg === ApuErrorLabels.NONMSA_SERVICE_ORDER_EMPTY_ERROR){
    errorTitle = ApuErrorLabels.ALL_FIELDS_EMPTY_ERROR;
         }
         else if (errorMsg === ApuErrorLabels.NON_MSA_SERVICE_ORDER_ERROR_INVALID) {
            errorTitle = ApuErrorLabels.SERVICE_ORDER_NO_INVALID;
        }
         else if (errorMsg === ApuErrorLabels.NONMSA_SERVICE_ORDER_DUBLICATE_ERROR || errorMsg === ApuErrorLabels.NONMSA_SERVICE_ORDER_DUBLICATE_CART_ERROR)
         {
           errorTitle = ApuErrorLabels.SERVICE_ORDER_DUBLICATE;
         }

    else {
       errorTitle = ApuErrorLabels.NONMSA_SERVICE_ORDER_INVALID_TITLE;
    }
}
         if (data.serialNumberError !== '') {
             errorMsg = data.serialNumberError;
             if (errorMsg === ApuErrorLabels.MSA_SERIAL_ERROR_EMPTY) {
                    errorTitle = ApuErrorLabels.ALL_FIELDS_EMPTY_ERROR;
                }
                else if (errorMsg === ApuErrorLabels.MSA_SERIAL_ERROR_INVALID) {
                    errorTitle = ApuErrorLabels.SERIAL_NUMBER_INVALID;
                }
        else {
            errorTitle = ApuErrorLabels.SERIAL_NUMBER_DUBLICATE;
            }
        }
         if (this.props.showAPUValidationErrorMsg) {
         if (errorTitle === ApuErrorLabels.ALL_FIELDS_EMPTY_ERROR ) {
         return  <Notification hasIcon={true} severity="important"  title={errorTitle} style={{margin: 0}} onCloseClick={() => {this.props.hideAPUValidationErrMsg(); }} >{errorMsg}</Notification>;
        }
        else {
            return  <Notification hasIcon={true} severity="critical"  title={errorTitle} style={{margin: 0}} onCloseClick={() => {this.props.hideAPUValidationErrMsg(); }} >{errorMsg}</Notification>;
        }
        }
        else {
            return ;
        }
    }

    addAPUMultipleRow() {
        let isError = false;
        this.props.serviceOrderDatas.forEach((product: any) => {
            if (typeof product.validInputData !== 'undefined' && !product.validInputData && product.serviceOrderNumberError !== '') {
                isError = true;
            }

        });

        if (!isError) {
          this.props.addRow();
        }
        this.props.hideAPUValidationErrMsg(true);
    }
    updateRowValue(cellValue: string, cellData: ICellData): void {
        this.updateSelectedRowData(cellData)
        this.props.hideAPUValidationErrMsg(true);
        if (cellData.field === 'serialNumber') {
              this.props.updateNonMsaSerial(cellValue, cellData.rowIndex);
          }
          else if (cellData.field === 'serviceOrderNumber') {
              this.props.updateNonMsaServiceOrder(cellValue, cellData.rowIndex);
          }
    }

    deleteMultipleItems(): void {
        this.props.deleteNonMsaSORow(this.state.selectedRowData);
        this.setState({ selectedRowData: [] });
      }
      updateSelectedRowData(cellData: ICellData) {
        if (this.state.selectedRowData.length !== 0) {
            const indexFromSelectedRowData = this.state.selectedRowData.findIndex((x: any) => (x.serviceOrderNumber === cellData.rowData.serviceOrderNumber) && (x.serialNumber === cellData.rowData.serialNumber));
            if (indexFromSelectedRowData !== -1) {
                    let  selecedData = [...this.state.selectedRowData];
                    selecedData.splice(indexFromSelectedRowData, 1);
                    this.setState({selectedRowData: selecedData});
            }
        }
  }

  serialNumberRenderer(cellData: ICellData) {
    return (
        <Input placeholder="Enter Serial No." disabled={false} type="string" className="so datatable-text-input" fluid={true} value={cellData.rowData.serialNumber} onChange={(newVal: string) => this.updateRowValue(newVal, cellData)} />
    );
}

serviceOrderNumberRenderer(cellData: ICellData) {
    return (
        <Input placeholder="Enter Order No." disabled={false} type="string" className="so datatable-text-input" fluid={true} value={cellData.rowData.serviceOrderNumber} onChange={(newVal: string) => this.updateRowValue(newVal, cellData)} />
    );
}
}

const mapDispatchToProps = {
    updateNonMsaSerial: ConfigureAPUActions.updateNonMsaSOSerial,
    updateNonMsaServiceOrder : ConfigureAPUActions.updateNonMsaSONumber,
    addRow : ConfigureAPUActions.addNonMsaSORow,
    deleteNonMsaSORow: ConfigureAPUActions.deleteNonMsaSORow,
    hideAPUValidationErrMsg : ConfigureAPUActions.hideAPUValidationErrorMsg


};
function mapStateToProps(state: any) {
    return {
        serviceOrderDatas : state.configAPUData.payload.nonMsaServiceOrderConfigData,
        enableNextBtn: state.configAPUData.payload.enableNextBtn,
        featuresMasterData: state.configAPUData.payload.featuresMasterData,
        NonMsaServiceOrderErrorRowData: state.configAPUData.payload.NonMsaServiceOrderErrorRowData,
        isValidateServiceOrderSuccess: state.configAPUData.payload.isValidateServiceOrderSuccess,
        isValidateServiceOrder: state.configAPUData.payload.isValidateServiceOrder,
        showAPUValidationErrorMsg: state.configAPUData.payload.showAPUValidationErrorMsg,

    };
}

export default connect(mapStateToProps, mapDispatchToProps)(NonMSAServiceOrder);
